import { APP_CREATION_STEPS } from './constants';
import translator from '@/locales';

function getDraftAppPrevStep(currentStep) {
  const steps = Object.values(APP_CREATION_STEPS);
  const indexOfCurrentStep = steps.findIndex(step => step === currentStep);

  if (indexOfCurrentStep === -1) {
    throw Error(translator.t('UNKNOWN_ERROR'));
  }

  if (indexOfCurrentStep === 0) {
    return null;
  }

  return steps[indexOfCurrentStep - 1];
}

export default getDraftAppPrevStep;
